import React from 'react'
import { ButtonBase, Text } from '@/components/common'
import LoginForm from './LoginForm'
import ResetPasswordForm from './ResetPasswordForm'

const LoginOptions = ({ email, setEmail, view, setView }) => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-between">
      {view === 'resetPassword' ? (
        <ResetPasswordForm
          email={email}
          setEmail={setEmail}
          view={view}
          setView={setView}
        />
      ) : (
        <LoginForm
          email={email}
          setEmail={setEmail}
          view={view}
          setView={setView}
        />
      )}
      <div className="mt-6 flex w-full flex-col items-center">
        <Text as="h4" preset="heading.sm">
          Not a member?
        </Text>
        <ButtonBase
          className="text-sm text-core-oxide"
          onClick={() => setView('register')}
        >
          Sign Up
        </ButtonBase>
      </div>
    </div>
  )
}

export default LoginOptions
